<template>
    <v-container fluid class="pa-0">
        <v-row>
            <v-col cols="12" class="h4" v-if="!hideHeader">
                Spill and Complaints Report
            </v-col>
            <v-col cols="12" class="mt-2">
                Click below to generate and download the spill and complaints report.  Please allow a few moments for the report to download on your browser.
            </v-col>
            <v-col cols="12">
                <v-alert v-show="reportLoading" type="info" v-if="!reportError">
                    Please wait while report is being generated. Report will be downloaded to your browswer once generated.
                </v-alert>
                <v-alert v-show="reportError" type="error">
                    An error occurred during report generation.  Please try again later.
                </v-alert>
                <v-btn v-if="!reportError" :disabled="reportLoading" color="primary" @click="genReport()">Download Report</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import publicReportService from '@/services/publicReportService'
import fileService from '@/services/util/fileService'
export default {
    props: {
        hideHeader: { default: false }
    },
    data () {
        return {
            reportLoading: false,
            reportError: false
        }
    },
    mounted () {
    },
    computed: {
    },
    methods: {
        genReport () {
            this.reportLoading = true
            publicReportService.getIncidentPublicReport(this.$http).then(response => {
                fileService.fileToDownload(response, `Spill-List_${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.csv`)
                this.reportLoading = false
            }).catch(error => {
                console.log(error)
                this.reportError = true
                setTimeout(() => {
                    this.reportError = false
                    this.reportLoading = false
                }, 15000)
            })
        }
    }
}
</script>
